import { jsx as o, jsxs as l, Fragment as ut } from "react/jsx-runtime";
import { MessagePrimitive as j, useAuiState as y, ComposerPrimitive as S, useAui as X, AttachmentPrimitive as B, useScrollLock as xe, useToolCallElapsed as mt, groupPartByType as pt, ThreadPrimitive as P, AuiIf as T, ErrorPrimitive as oe, ActionBarPrimitive as H, ActionBarMorePrimitive as ft } from "@assistant-ui/react";
import { X as gt, PlusIcon as ht, FileText as bt, XIcon as xt, LoaderIcon as ve, ChevronDownIcon as Ne, CopyIcon as K, CheckIcon as $, XCircleIcon as we, AlertCircleIcon as vt, ArrowDownIcon as Nt, Loader2Icon as wt, MoreHorizontalIcon as yt, MicIcon as kt, SquareIcon as ae, ArrowUpIcon as Ct } from "lucide-react";
import { DateTime as G } from "luxon";
import * as _ from "react";
import At, { forwardRef as Tt, useState as C, useEffect as q, createContext as O, useRef as J, useCallback as Y, useMemo as L, useContext as N, memo as ye } from "react";
import { aq as ke, T as Ce, s as Ae, cw as R, t as Te, aD as Ie, aT as It, cx as Rt } from "../TabGroup-B4jOGf3W.js";
import "immutable";
import "fast-levenshtein";
import "fuzzy";
import "fast-deep-equal";
import "../references-BRMYEcTr.js";
import "react-dom";
import "@tanstack/react-virtual";
import { c as i } from "../cn-B6yFEsav.js";
import "@radix-ui/react-checkbox";
import "react-day-picker";
import { Slot as St } from "radix-ui";
import "@radix-ui/react-switch";
import * as A from "@radix-ui/react-dialog";
import * as U from "@radix-ui/react-avatar";
import * as Q from "@radix-ui/react-collapsible";
import { unstable_memoizeMarkdownComponents as Et, useIsMarkdownCodeBlock as Mt, MarkdownTextPrimitive as Ot } from "@assistant-ui/react-markdown";
import ne from "remark-gfm";
const re = (e) => Symbol.iterator in e, ie = (e) => (
  // HACK: avoid checking entries type
  "entries" in e
), se = (e, t) => {
  const a = e instanceof Map ? e : new Map(e.entries()), n = t instanceof Map ? t : new Map(t.entries());
  if (a.size !== n.size)
    return !1;
  for (const [r, s] of a)
    if (!n.has(r) || !Object.is(s, n.get(r)))
      return !1;
  return !0;
}, _t = (e, t) => {
  const a = e[Symbol.iterator](), n = t[Symbol.iterator]();
  let r = a.next(), s = n.next();
  for (; !r.done && !s.done; ) {
    if (!Object.is(r.value, s.value))
      return !1;
    r = a.next(), s = n.next();
  }
  return !!r.done && !!s.done;
};
function Dt(e, t) {
  return Object.is(e, t) ? !0 : typeof e != "object" || e === null || typeof t != "object" || t === null || Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? !1 : re(e) && re(t) ? ie(e) && ie(t) ? se(e, t) : _t(e, t) : se(
    { entries: () => Object.entries(e) },
    { entries: () => Object.entries(t) }
  );
}
function zt(e) {
  const t = At.useRef(void 0);
  return (a) => {
    const n = e(a);
    return Dt(t.current, n) ? t.current : t.current = n;
  };
}
const Pt = A.Root, Lt = A.Trigger, jt = A.Portal, Re = _.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ o(ke.Consumer, { children: ({ zIndex: n }) => /* @__PURE__ */ o(
  A.Overlay,
  {
    ref: a,
    className: i(
      "fixed inset-0 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    style: { zIndex: n, ...t.style }
  }
) }));
Re.displayName = A.Overlay.displayName;
const Se = _.forwardRef(({ className: e, children: t, ...a }, n) => /* @__PURE__ */ l(jt, { children: [
  /* @__PURE__ */ o(Re, {}),
  /* @__PURE__ */ o(ke.Consumer, { children: ({ zIndex: r }) => /* @__PURE__ */ l(
    A.Content,
    {
      ref: n,
      className: i(
        "fixed left-[50%] top-[50%] grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...a,
      style: { zIndex: r, ...a.style },
      children: [
        t,
        /* @__PURE__ */ l(A.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ o(gt, { className: "h-4 w-4" }),
          /* @__PURE__ */ o("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  ) })
] }));
Se.displayName = A.Content.displayName;
const Ee = _.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ o(
  A.Title,
  {
    ref: a,
    className: i("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
Ee.displayName = A.Title.displayName;
const Ut = _.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ o(A.Description, { ref: a, className: i("text-sm text-muted-foreground", e), ...t }));
Ut.displayName = A.Description.displayName;
const Me = _.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ o(
  U.Root,
  {
    ref: a,
    className: i(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      e
    ),
    ...t
  }
));
Me.displayName = U.Root.displayName;
const Oe = _.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ o(
  U.Image,
  {
    ref: a,
    className: i("aspect-square h-full w-full", e),
    ...t
  }
));
Oe.displayName = U.Image.displayName;
const _e = _.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ o(
  U.Fallback,
  {
    ref: a,
    className: i(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      e
    ),
    ...t
  }
));
_e.displayName = U.Fallback.displayName;
const I = Tt(
  ({ children: e, tooltip: t, side: a = "bottom", className: n, ...r }, s) => /* @__PURE__ */ l(Ce, { children: [
    /* @__PURE__ */ o(Ae, { asChild: !0, children: /* @__PURE__ */ l(
      R,
      {
        variant: "ghost",
        size: "icon",
        ...r,
        className: i("aui-button-icon size-6 p-1 active:scale-90", n),
        ref: s,
        children: [
          /* @__PURE__ */ o(St.Slottable, { children: e }),
          /* @__PURE__ */ o("span", { className: "aui-sr-only sr-only", children: t })
        ]
      }
    ) }),
    /* @__PURE__ */ o(Te, { side: a, children: t })
  ] })
);
I.displayName = "TooltipIconButton";
const Ft = (e) => {
  const [t, a] = C(void 0);
  return q(() => {
    if (!e) {
      a(void 0);
      return;
    }
    const n = URL.createObjectURL(e);
    return a(n), () => {
      URL.revokeObjectURL(n);
    };
  }, [e]), t;
}, De = () => {
  const { file: e, src: t } = y(
    zt((a) => {
      if (a.attachment.type !== "image") return {};
      if (a.attachment.file) return { file: a.attachment.file };
      const n = a.attachment.content?.filter((r) => r.type === "image")[0]?.image;
      return n ? { src: n } : {};
    })
  );
  return Ft(e) ?? t;
}, Bt = ({ src: e }) => {
  const [t, a] = C(!1);
  return /* @__PURE__ */ o(
    "img",
    {
      src: e,
      alt: "Attachment preview",
      className: i(
        "block h-auto max-h-[80vh] w-auto max-w-full object-contain",
        t ? "aui-attachment-preview-image-loaded" : "aui-attachment-preview-image-loading invisible"
      ),
      onLoad: () => a(!0)
    }
  );
}, Ht = ({ children: e }) => {
  const t = De();
  return t ? /* @__PURE__ */ l(Pt, { children: [
    /* @__PURE__ */ o(
      Lt,
      {
        className: "aui-attachment-preview-trigger hover:bg-accent/50 cursor-pointer transition-colors",
        asChild: !0,
        children: e
      }
    ),
    /* @__PURE__ */ l(Se, { className: "aui-attachment-preview-dialog-content [&>button]:bg-foreground/60 [&_svg]:text-background [&>button]:hover:[&_svg]:text-destructive p-2 sm:max-w-3xl [&>button]:rounded-full [&>button]:p-1 [&>button]:opacity-100 [&>button]:ring-0!", children: [
      /* @__PURE__ */ o(Ee, { className: "aui-sr-only sr-only", children: "Image Attachment Preview" }),
      /* @__PURE__ */ o("div", { className: "aui-attachment-preview bg-background relative mx-auto flex max-h-[80dvh] w-full items-center justify-center overflow-hidden", children: /* @__PURE__ */ o(Bt, { src: t }) })
    ] })
  ] }) : e;
}, $t = () => {
  const e = De();
  return /* @__PURE__ */ l(Me, { className: "aui-attachment-tile-avatar h-full w-full rounded-none", children: [
    /* @__PURE__ */ o(Oe, { src: e, alt: "Attachment preview", className: "aui-attachment-tile-image object-cover" }),
    /* @__PURE__ */ o(_e, { children: /* @__PURE__ */ o(bt, { className: "aui-attachment-tile-fallback-icon text-muted-foreground size-8" }) })
  ] });
}, ze = () => y((t) => t.attachment.type === "image") ? /* @__PURE__ */ o(Gt, {}) : /* @__PURE__ */ o(Wt, {}), Pe = "h-14", Le = "bg-muted overflow-hidden rounded-lg border", je = "absolute end-1.5 top-1.5 bg-[var(--palette-N100)] opacity-100 shadow-sm hover:bg-[var(--palette-N200)]!";
function qt(e) {
  const t = e.lastIndexOf("."), a = t > 0 ? e.slice(t + 1) : "";
  return a.length > 0 && a.length <= 4 ? a : "file";
}
const Gt = () => {
  const t = X().attachment.source !== "message", a = y((n) => n.attachment.status?.type === "running");
  return /* @__PURE__ */ l(Ce, { children: [
    /* @__PURE__ */ l(
      B.Root,
      {
        className: i(
          "aui-attachment-root relative shrink-0",
          !t && "aui-attachment-root-message only:*:first:size-24"
        ),
        children: [
          /* @__PURE__ */ o(Ht, { children: /* @__PURE__ */ o(Ae, { asChild: !0, children: /* @__PURE__ */ l(
            "button",
            {
              type: "button",
              className: i(
                "aui-attachment-tile relative aspect-square cursor-pointer p-0 transition-opacity hover:opacity-75",
                Pe,
                Le
              ),
              "aria-label": "Image attachment",
              children: [
                /* @__PURE__ */ o($t, {}),
                a && /* @__PURE__ */ o("div", { className: "aui-attachment-tile-processing bg-background/60 absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ o(Ie, { value: "indeterminate", outerDiameter: 20, innerDiameter: 16 }) })
              ]
            }
          ) }) }),
          t && /* @__PURE__ */ o(Ue, { className: je })
        ]
      }
    ),
    /* @__PURE__ */ o(Te, { side: "top", children: /* @__PURE__ */ o(B.Name, {}) })
  ] });
}, Wt = () => {
  const t = X().attachment.source !== "message", a = y((r) => r.attachment.status?.type === "running"), n = y((r) => r.attachment.name);
  return /* @__PURE__ */ l(
    B.Root,
    {
      className: i(
        // A fixed width, twice the tile's — not one that follows the name. Reading the whole
        // filename isn't the point: the badge below already says what KIND of file it is, and
        // the full name is a hover away. A predictable card keeps a row of them aligned.
        "aui-attachment-card relative flex w-28 shrink-0 flex-col justify-between px-2 py-1.5",
        Pe,
        Le
      ),
      title: n,
      children: [
        /* @__PURE__ */ o("span", { className: i("aui-attachment-card-name text-foreground truncate text-xs", t && "pe-4"), children: /* @__PURE__ */ o(B.Name, {}) }),
        a ? /* @__PURE__ */ o(Ie, { value: "indeterminate", outerDiameter: 16, innerDiameter: 12 }) : /* @__PURE__ */ o("span", { className: "aui-attachment-card-kind text-muted-foreground self-start rounded border px-1 text-[10px] font-medium uppercase", children: qt(n) }),
        t && /* @__PURE__ */ o(Ue, { className: je })
      ]
    }
  );
}, Ue = ({ className: e }) => /* @__PURE__ */ o(B.Remove, { asChild: !0, children: /* @__PURE__ */ o(
  I,
  {
    tooltip: "Remove file",
    className: i(
      // 18px with 2px of padding around a 12px glyph: the disc used to be 14px wide with the
      // glyph filling it corner to corner, which read as a cramped mark rather than a button.
      // N600 is a dark grey — legible on the light disc without the hardness of black.
      "aui-attachment-tile-remove hover:[&_svg]:text-destructive size-4.5 rounded-full p-0.5 text-[var(--palette-N600)]",
      e
    ),
    side: "top",
    children: /* @__PURE__ */ o(xt, { className: "aui-attachment-remove-icon size-3 dark:stroke-[2.5px]" })
  }
) }), Vt = () => (
  // Wraps because a message has no sideways scroll to fall back on (the composer's row does):
  // past the width of the bubble, attachments stack onto another line rather than overflow it.
  /* @__PURE__ */ o("div", { className: "aui-user-message-attachments-end col-span-full col-start-1 row-start-1 flex w-full flex-row flex-wrap items-center justify-end gap-2", children: /* @__PURE__ */ o(j.Attachments, { children: () => /* @__PURE__ */ o(ze, {}) }) })
), Xt = () => (
  // Wraps rather than scrolls: attachments follow whatever width the panel has right now
  // (docked, wide, full-screen), stacking onto another line instead of hiding off the edge.
  /* @__PURE__ */ o("div", { className: "aui-composer-attachments flex w-full flex-row flex-wrap items-center gap-2 empty:hidden", children: /* @__PURE__ */ o(S.Attachments, { children: () => /* @__PURE__ */ o(ze, {}) }) })
), Kt = () => /* @__PURE__ */ o(S.AddAttachment, { asChild: !0, children: /* @__PURE__ */ o(
  I,
  {
    tooltip: "Add Attachment",
    side: "bottom",
    variant: "ghost",
    size: "icon",
    className: "aui-composer-add-attachment hover:bg-muted-foreground/15 dark:border-muted-foreground/15 dark:hover:bg-muted-foreground/30 size-7 rounded-full p-1 text-xs font-semibold",
    "aria-label": "Add Attachment",
    children: /* @__PURE__ */ o(ht, { className: "aui-attachment-add-icon size-4.5 stroke-[1.5px]" })
  }
) }), Fe = Q.Root, Be = Q.CollapsibleTrigger, He = Q.CollapsibleContent, le = 200, Jt = 100, $e = ["Working"], Yt = 3e3, Qt = () => {
}, Zt = { inExecution: !1, detailsShown: !1, setDetailsShown: Qt }, qe = O(Zt);
function Z() {
  return N(qe);
}
function eo({
  className: e,
  active: t = !1,
  open: a,
  onOpenChange: n,
  defaultOpen: r = !1,
  children: s,
  ...c
}) {
  const u = J(null), [b, m] = C(null), [f, d] = C(!1), g = xe(u, le), h = a !== void 0, v = h ? a : b ?? r, k = Y(
    (p) => {
      g(), h || m(p), n?.(p);
    },
    [g, h, n]
  ), x = L(
    () => ({ inExecution: !0, detailsShown: f, setDetailsShown: d }),
    [f]
  );
  return /* @__PURE__ */ o(
    Fe,
    {
      ref: u,
      "data-slot": "execution-root",
      "data-active": t || void 0,
      open: v,
      onOpenChange: k,
      className: i("aui-execution-root group/execution-root w-full text-xs", e),
      style: { "--animation-duration": `${le}ms` },
      ...c,
      children: /* @__PURE__ */ o(qe.Provider, { value: x, children: s })
    }
  );
}
const to = (e) => {
  if (e < 1e3) return "<1s";
  const t = e / 1e3;
  return t < 10 ? `${(Math.floor(t * 10) / 10).toFixed(1)}s` : t < 60 ? `${Math.floor(t)}s` : `${Math.floor(t / 60)}m ${Math.floor(t % 60)}s`;
};
function oo({ active: e, startedAt: t }) {
  const [a, n] = C(), r = J(void 0);
  return q(() => {
    if (!e) return;
    r.current ??= t ?? Date.now();
    const s = r.current, c = () => n(Date.now() - s);
    c();
    const u = window.setInterval(c, Jt);
    return () => window.clearInterval(u);
  }, [e, t]), a === void 0 ? null : /* @__PURE__ */ o("span", { "data-slot": "execution-duration", className: "aui-execution-duration shrink-0 tabular-nums", children: to(a) });
}
function ao({ active: e, labels: t }) {
  const [a, n] = C(() => Math.floor(Math.random() * t.length)), r = e && t.length > 1;
  q(() => {
    if (!r) return;
    const c = window.setInterval(() => n((u) => (u + 1) % t.length), Yt);
    return () => window.clearInterval(c);
  }, [r, t.length]);
  const s = e ? t[a % t.length] ?? $e[0] : "Worked";
  return /* @__PURE__ */ l(
    "span",
    {
      "data-slot": "execution-trigger-title",
      className: i(
        "aui-execution-trigger-title relative inline-block shrink-0 leading-none font-medium",
        r && "animate-in fade-in duration-500 motion-reduce:animate-none",
        e && "text-foreground"
      ),
      children: [
        /* @__PURE__ */ o("span", { children: s }),
        e ? /* @__PURE__ */ o(
          "span",
          {
            "aria-hidden": !0,
            "data-slot": "execution-trigger-shimmer",
            className: "aui-execution-trigger-shimmer shimmer pointer-events-none absolute inset-0 motion-reduce:animate-none",
            children: s
          }
        ) : null
      ]
    },
    r ? s : void 0
  );
}
function no({
  active: e = !1,
  detail: t,
  startedAt: a,
  workingLabels: n = $e,
  className: r,
  ...s
}) {
  return /* @__PURE__ */ l(
    Be,
    {
      "data-slot": "execution-trigger",
      className: i(
        "aui-execution-trigger group/trigger text-muted-foreground hover:text-foreground flex w-full origin-left items-center gap-2 py-1 text-start transition-[color,scale] active:scale-[0.98]",
        r
      ),
      ...s,
      children: [
        e ? /* @__PURE__ */ o(
          ve,
          {
            "data-slot": "execution-trigger-icon",
            className: "aui-execution-trigger-icon size-3.5 shrink-0 animate-spin [animation-duration:0.6s]"
          }
        ) : null,
        /* @__PURE__ */ o(ao, { active: e, labels: n }),
        /* @__PURE__ */ o(oo, { active: e, startedAt: a }),
        t ? /* @__PURE__ */ l("span", { "data-slot": "execution-trigger-detail", className: "aui-execution-trigger-detail min-w-0 truncate", children: [
          "— ",
          t
        ] }) : null,
        /* @__PURE__ */ o(
          Ne,
          {
            "data-slot": "execution-trigger-chevron",
            className: i(
              // Adjacent to the label, not pushed to the row's end: the row is as wide as the
              // reading lane, so an `ms-auto` chevron ends up stranded in whitespace once the
              // lane widens (full-screen chat). The row stays full-width for the hit area.
              "aui-execution-trigger-chevron size-3.5 shrink-0",
              "transition-transform duration-(--animation-duration) ease-[cubic-bezier(0.32,0.72,0,1)] motion-reduce:transition-none",
              "group-data-[state=closed]/trigger:-rotate-90",
              "group-data-[state=open]/trigger:rotate-0"
            )
          }
        )
      ]
    }
  );
}
function ro({ className: e, children: t, ...a }) {
  return /* @__PURE__ */ o(
    He,
    {
      "data-slot": "execution-content",
      className: i(
        "aui-execution-content relative overflow-hidden outline-none",
        "group/collapsible-content ease-[cubic-bezier(0.32,0.72,0,1)] motion-reduce:animate-none",
        "data-[state=closed]:animate-collapsible-up",
        "data-[state=open]:animate-collapsible-down",
        "data-[state=closed]:fill-mode-forwards",
        "data-[state=closed]:pointer-events-none",
        "data-[state=open]:duration-(--animation-duration)",
        "data-[state=closed]:duration-(--animation-duration)",
        e
      ),
      ...a,
      children: /* @__PURE__ */ o(
        "div",
        {
          className: i(
            "flex flex-col gap-1.5 pt-1 pb-2 ps-1",
            // Tool rows are sized for the message flow; inside the panel they are secondary
            // content and follow the panel's smaller type. Addressed by slot because the
            // rows come from `tool-fallback.tsx`, which owns its own default sizing.
            "[&_[data-slot=tool-fallback-trigger]]:text-xs [&_[data-slot=tool-fallback-content]]:text-xs",
            "group-data-[state=open]/collapsible-content:animate-in group-data-[state=open]/collapsible-content:fade-in-0 group-data-[state=open]/collapsible-content:blur-in-[2px] group-data-[state=open]/collapsible-content:slide-in-from-top-1",
            "group-data-[state=closed]/collapsible-content:animate-out group-data-[state=closed]/collapsible-content:fade-out-0 group-data-[state=closed]/collapsible-content:blur-out-[2px] group-data-[state=closed]/collapsible-content:slide-out-to-top-1",
            "group-data-[state=open]/collapsible-content:duration-(--animation-duration) group-data-[state=closed]/collapsible-content:duration-(--animation-duration)"
          ),
          children: t
        }
      )
    }
  );
}
function io({ className: e, children: t, ...a }) {
  return /* @__PURE__ */ o("ol", { "data-slot": "execution-steps", className: i("aui-execution-steps flex flex-col", e), ...a, children: t });
}
function Ge({ active: e = !1, className: t, children: a, ...n }) {
  return /* @__PURE__ */ l(
    "li",
    {
      "data-slot": "execution-step",
      "data-active": e || void 0,
      className: i(
        "aui-execution-step relative pb-1.5 ps-5 last:pb-0",
        // The rail joining consecutive steps, ending at the last one.
        "before:bg-border before:absolute before:start-[3px] before:top-4 before:bottom-0 before:w-px before:content-[''] last:before:hidden",
        t
      ),
      ...n,
      children: [
        /* @__PURE__ */ o(
          "span",
          {
            "aria-hidden": !0,
            "data-slot": "execution-step-marker",
            className: i(
              "aui-execution-step-marker absolute start-0 top-[5px] size-[7px] rounded-full",
              // The current step breathes, so the panel reads as live even when the step's
              // label sits still for a while. Stops on its own: `active` is the part's
              // "running" status, and a step that has finished renders the plain dot.
              e ? "bg-primary ring-primary/20 animate-pulse ring-3 motion-reduce:animate-none" : "bg-muted-foreground/40"
            )
          }
        ),
        /* @__PURE__ */ o("div", { className: i("aui-execution-step-body min-w-0", e ? "text-foreground" : "text-muted-foreground"), children: a })
      ]
    }
  );
}
function so({ className: e, ...t }) {
  const { detailsShown: a, setDetailsShown: n } = Z();
  return /* @__PURE__ */ o(
    "button",
    {
      type: "button",
      "data-slot": "execution-details-toggle",
      "aria-expanded": a,
      onClick: () => n(!a),
      className: i(
        "aui-execution-details-toggle text-muted-foreground hover:text-foreground w-fit underline underline-offset-2 transition-colors",
        e
      ),
      ...t,
      children: a ? "Hide details and tools" : "Show details and tools"
    }
  );
}
const ce = "sphere-handle:", We = O(void 0);
function pa({
  resolve: e,
  children: t
}) {
  return /* @__PURE__ */ o(We.Provider, { value: e, children: t });
}
function lo() {
  return N(We);
}
function co(e) {
  if (typeof e != "string" || !e.toLowerCase().startsWith(ce)) return;
  const t = e.slice(ce.length).replace(/^\/+/, "");
  return t === "" ? void 0 : t;
}
function Ve(e, t) {
  const a = e.children;
  if (!Array.isArray(a)) return;
  let n = 0;
  for (; n < a.length; ) {
    const r = a[n];
    if (r === void 0) {
      n += 1;
      continue;
    }
    const s = r.type === "link" ? co(r.url) : void 0;
    if (s !== void 0) {
      const c = t(s);
      if (c !== void 0)
        r.url = c, n += 1;
      else {
        const u = r.children ?? [];
        a.splice(n, 1, ...u), n += u.length;
      }
      continue;
    }
    Ve(r, t), n += 1;
  }
}
function uo({ resolve: e }) {
  return (t) => {
    Ve(t, e);
  };
}
const mo = () => {
  const e = lo(), t = L(
    () => e ? [ne, [uo, { resolve: e }]] : [ne],
    [e]
  );
  return /* @__PURE__ */ o(
    Ot,
    {
      remarkPlugins: t,
      className: "aui-md [&>*:not(.aui-md-table-scroll):not(.aui-md-pre)]:mx-auto [&>*:not(.aui-md-table-scroll):not(.aui-md-pre)]:max-w-(--thread-max-width)",
      components: go,
      defer: !0
    }
  );
}, de = ye(mo), po = ({ language: e, code: t }) => {
  const { isCopied: a, copyToClipboard: n } = fo();
  return /* @__PURE__ */ l("div", { className: "aui-code-header-root border-border/50 bg-muted/50 mt-3 flex items-center justify-between rounded-t-xl border border-b-0 px-3.5 py-1.5 text-xs", children: [
    /* @__PURE__ */ o("span", { className: "aui-code-header-language text-muted-foreground font-medium lowercase", children: e }),
    /* @__PURE__ */ l(I, { tooltip: "Copy", onClick: () => {
      !t || a || n(t);
    }, children: [
      !a && /* @__PURE__ */ o(K, { className: "animate-in zoom-in-75 fade-in duration-150" }),
      a && /* @__PURE__ */ o($, { className: "animate-in zoom-in-50 fade-in duration-200 ease-out" })
    ] })
  ] });
}, fo = ({ copiedDuration: e = 3e3 } = {}) => {
  const [t, a] = C(!1);
  return q(() => {
    if (!t)
      return;
    const r = setTimeout(() => a(!1), e);
    return () => clearTimeout(r);
  }, [t, e]), { isCopied: t, copyToClipboard: (r) => {
    !r || typeof navigator > "u" || !navigator.clipboard || navigator.clipboard.writeText(r).then(
      () => {
        a(!0);
      },
      () => {
      }
    );
  } };
}, go = Et({
  h1: ({ className: e, ...t }) => /* @__PURE__ */ o(
    "h1",
    {
      className: i("aui-md-h1 mt-5 mb-2 scroll-m-20 text-xl font-semibold first:mt-0 last:mb-0", e),
      ...t
    }
  ),
  h2: ({ className: e, ...t }) => /* @__PURE__ */ o(
    "h2",
    {
      className: i("aui-md-h2 mt-5 mb-2 scroll-m-20 text-lg font-semibold first:mt-0 last:mb-0", e),
      ...t
    }
  ),
  h3: ({ className: e, ...t }) => /* @__PURE__ */ o(
    "h3",
    {
      className: i("aui-md-h3 mt-4 mb-1.5 scroll-m-20 text-base font-semibold first:mt-0 last:mb-0", e),
      ...t
    }
  ),
  h4: ({ className: e, ...t }) => /* @__PURE__ */ o(
    "h4",
    {
      className: i("aui-md-h4 mt-3.5 mb-1 scroll-m-20 text-base font-medium first:mt-0 last:mb-0", e),
      ...t
    }
  ),
  h5: ({ className: e, ...t }) => /* @__PURE__ */ o("h5", { className: i("aui-md-h5 mt-3 mb-1 text-sm font-semibold first:mt-0 last:mb-0", e), ...t }),
  h6: ({ className: e, ...t }) => /* @__PURE__ */ o("h6", { className: i("aui-md-h6 mt-3 mb-1 text-sm font-medium first:mt-0 last:mb-0", e), ...t }),
  p: ({ className: e, ...t }) => /* @__PURE__ */ o("p", { className: i("aui-md-p my-3 leading-relaxed first:mt-0 last:mb-0", e), ...t }),
  a: ({ className: e, ...t }) => /* @__PURE__ */ o(
    "a",
    {
      className: i("aui-md-a text-primary hover:text-primary/80 underline underline-offset-2", e),
      ...t
    }
  ),
  blockquote: ({ className: e, ...t }) => /* @__PURE__ */ o(
    "blockquote",
    {
      className: i(
        "aui-md-blockquote border-muted-foreground/30 text-muted-foreground my-3 border-s-2 ps-4",
        e
      ),
      ...t
    }
  ),
  ul: ({ className: e, ...t }) => /* @__PURE__ */ o(
    "ul",
    {
      className: i("aui-md-ul marker:text-muted-foreground my-3 ms-5 list-disc [&>li]:mt-1", e),
      ...t
    }
  ),
  ol: ({ className: e, ...t }) => /* @__PURE__ */ o(
    "ol",
    {
      className: i("aui-md-ol marker:text-muted-foreground my-3 ms-5 list-decimal [&>li]:mt-1", e),
      ...t
    }
  ),
  hr: ({ className: e, ...t }) => /* @__PURE__ */ o("hr", { className: i("aui-md-hr border-muted-foreground/20 my-3", e), ...t }),
  table: ({ className: e, ...t }) => /* @__PURE__ */ o("div", { className: "aui-md-table-scroll my-3 w-full overflow-x-auto", children: /* @__PURE__ */ o("table", { className: i("aui-md-table w-max min-w-full border-separate border-spacing-0", e), ...t }) }),
  th: ({ className: e, children: t, ...a }) => /* @__PURE__ */ o(
    "th",
    {
      className: i(
        "aui-md-th bg-muted max-w-36 break-words px-3 py-1.5 text-start font-medium first:rounded-ss-lg last:rounded-se-lg [[align=center]]:text-center [[align=right]]:text-right",
        e
      ),
      ...a,
      children: t
    }
  ),
  td: ({ className: e, children: t, ...a }) => /* @__PURE__ */ o(
    "td",
    {
      className: i(
        "aui-md-td border-muted-foreground/20 max-w-36 break-words border-s border-b px-3 py-1.5 text-start last:border-e [[align=center]]:text-center [[align=right]]:text-right",
        e
      ),
      ...a,
      children: t
    }
  ),
  tr: ({ className: e, ...t }) => /* @__PURE__ */ o(
    "tr",
    {
      className: i(
        "aui-md-tr m-0 border-b p-0 first:border-t [&:last-child>td:first-child]:rounded-es-lg [&:last-child>td:last-child]:rounded-ee-lg",
        e
      ),
      ...t
    }
  ),
  li: ({ className: e, ...t }) => /* @__PURE__ */ o("li", { className: i("aui-md-li leading-relaxed", e), ...t }),
  strong: ({ className: e, ...t }) => /* @__PURE__ */ o("strong", { className: i("aui-md-strong font-semibold", e), ...t }),
  sup: ({ className: e, ...t }) => /* @__PURE__ */ o("sup", { className: i("aui-md-sup [&>a]:text-xs [&>a]:no-underline", e), ...t }),
  pre: ({ className: e, ...t }) => /* @__PURE__ */ o(
    "pre",
    {
      className: i(
        "aui-md-pre border-border/50 bg-muted/30 overflow-x-auto rounded-t-none rounded-b-xl border border-t-0 p-3.5 text-[13px] leading-relaxed",
        e
      ),
      ...t
    }
  ),
  code: function({ className: t, ...a }) {
    const n = Mt();
    return /* @__PURE__ */ o(
      "code",
      {
        className: i(
          !n && "aui-md-inline-code bg-muted rounded-md px-1.5 py-0.5 font-mono text-[0.85em]",
          t
        ),
        ...a
      }
    );
  },
  CodeHeader: po
});
function Xe(e, t) {
  const a = new Set(t);
  let n = -1;
  for (let s = 0; s < e.length; s++) {
    const c = e[s];
    c.type === "tool-call" && !a.has(c.toolName ?? "") && (n = s);
  }
  const r = /* @__PURE__ */ new Set();
  for (let s = 0; s < n; s++)
    e[s].type === "text" && r.add(e[s]);
  return r;
}
const ho = 240;
function bo(e, t, a, n = ho) {
  const r = e[t];
  return !a || r === void 0 || r.type !== "text" || t !== e.length - 1 ? !1 : (r.text ?? "").length < n;
}
const xo = 90;
function vo(e, t = xo) {
  const a = e.split(`
`).map((r) => r.trim()).find((r) => r.length > 0);
  if (a === void 0) return "";
  const n = a.replace(/^#{1,6}\s+/, "").replace(/^>\s*/, "").replace(/^(?:[-*+]|\d+\.)\s+/, "").replace(/[*_`]/g, "").trim();
  return n.length <= t ? n : `${n.slice(0, t - 1).trimEnd()}…`;
}
function ee(e) {
  if (e.type === "tool-call") {
    const a = e.toolName ?? "tool";
    return e.isError ? `Tool failed: ${a}` : e.status?.type === "incomplete" ? `Cancelled: ${a}` : e.status?.type === "running" ? `Using ${a}` : `Used ${a}`;
  }
  const t = vo(e.text ?? "");
  return t.length > 0 ? t : e.type === "reasoning" ? "Thinking" : "Working";
}
const ue = 200, z = "active:scale-[0.98]";
function Ke({
  className: e,
  open: t,
  onOpenChange: a,
  defaultOpen: n = !1,
  children: r,
  ...s
}) {
  const c = J(null), [u, b] = C(n), m = xe(c, ue), f = t !== void 0, d = f ? t : u, g = Y(
    (h) => {
      m(), f || b(h), a?.(h);
    },
    [m, f, a]
  );
  return /* @__PURE__ */ o(
    Fe,
    {
      ref: c,
      "data-slot": "tool-fallback-root",
      open: d,
      onOpenChange: g,
      className: i("aui-tool-fallback-root group/tool-fallback-root w-full", e),
      style: {
        "--animation-duration": `${ue}ms`
      },
      ...s,
      children: r
    }
  );
}
const No = {
  running: ve,
  complete: $,
  incomplete: we,
  "requires-action": vt
}, wo = (e) => {
  if (e < 1e3) return "<1s";
  const t = e / 1e3;
  return t < 10 ? `${(Math.floor(t * 10) / 10).toFixed(1)}s` : t < 60 ? `${Math.floor(t)}s` : `${Math.floor(t / 60)}m ${Math.floor(t % 60)}s`;
};
function yo({ className: e, ...t }) {
  const a = mt();
  return a === void 0 ? null : /* @__PURE__ */ o(
    "span",
    {
      "data-slot": "tool-fallback-duration",
      className: i("aui-tool-fallback-duration text-muted-foreground text-xs tabular-nums", e),
      ...t,
      children: wo(a)
    }
  );
}
function Je({
  toolName: e,
  status: t,
  isError: a,
  expandable: n = !0,
  className: r,
  ...s
}) {
  const c = t?.type ?? "complete", u = c === "running", b = t?.type === "incomplete" && t.reason === "cancelled", m = a ? we : No[c], f = b ? "Cancelled tool" : a ? "Tool failed" : "Used tool";
  return /* @__PURE__ */ l(
    n ? Be : "span",
    {
      "data-slot": "tool-fallback-trigger",
      "data-expandable": n ? void 0 : "false",
      className: i(
        "aui-tool-fallback-trigger group/trigger text-muted-foreground flex w-fit origin-left items-center gap-2 py-1.5 text-sm",
        n && "hover:text-foreground transition-[color,scale] active:scale-[0.98]",
        r
      ),
      ...s,
      children: [
        /* @__PURE__ */ o(
          m,
          {
            "data-slot": "tool-fallback-trigger-icon",
            className: i(
              "aui-tool-fallback-trigger-icon size-4 shrink-0",
              b && "text-muted-foreground",
              a && "text-destructive",
              u && "animate-spin [animation-duration:0.6s]"
            )
          }
        ),
        /* @__PURE__ */ l(
          "span",
          {
            "data-slot": "tool-fallback-trigger-label",
            className: i(
              "aui-tool-fallback-trigger-label-wrapper relative inline-block text-start leading-none",
              b && "text-muted-foreground line-through",
              a && "text-destructive"
            ),
            children: [
              /* @__PURE__ */ l("span", { children: [
                f,
                ": ",
                /* @__PURE__ */ o("b", { children: e })
              ] }),
              u && /* @__PURE__ */ l(
                "span",
                {
                  "aria-hidden": !0,
                  "data-slot": "tool-fallback-trigger-shimmer",
                  className: "aui-tool-fallback-trigger-shimmer shimmer pointer-events-none absolute inset-0 motion-reduce:animate-none",
                  children: [
                    f,
                    ": ",
                    /* @__PURE__ */ o("b", { children: e })
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ o(yo, {}),
        n && /* @__PURE__ */ o(
          Ne,
          {
            "data-slot": "tool-fallback-trigger-chevron",
            className: i(
              "aui-tool-fallback-trigger-chevron size-4 shrink-0",
              "transition-transform duration-(--animation-duration) ease-[cubic-bezier(0.32,0.72,0,1)] motion-reduce:transition-none",
              "group-data-[state=closed]/trigger:-rotate-90",
              "group-data-[state=open]/trigger:rotate-0"
            )
          }
        )
      ]
    }
  );
}
function Ye({ className: e, children: t, ...a }) {
  return /* @__PURE__ */ o(
    He,
    {
      "data-slot": "tool-fallback-content",
      className: i(
        "aui-tool-fallback-content relative overflow-hidden text-sm outline-none",
        "group/collapsible-content ease-[cubic-bezier(0.32,0.72,0,1)] motion-reduce:animate-none",
        "data-[state=closed]:animate-collapsible-up",
        "data-[state=open]:animate-collapsible-down",
        "data-[state=closed]:fill-mode-forwards",
        "data-[state=closed]:pointer-events-none",
        "data-[state=open]:duration-(--animation-duration)",
        "data-[state=closed]:duration-(--animation-duration)",
        e
      ),
      ...a,
      children: /* @__PURE__ */ o(
        "div",
        {
          className: i(
            "flex flex-col gap-2 ps-6 pt-1 pb-2 ease-[cubic-bezier(0.32,0.72,0,1)] motion-reduce:animate-none",
            "group-data-[state=open]/collapsible-content:animate-in group-data-[state=open]/collapsible-content:fade-in-0 group-data-[state=open]/collapsible-content:blur-in-[2px] group-data-[state=open]/collapsible-content:slide-in-from-top-1",
            "group-data-[state=closed]/collapsible-content:animate-out group-data-[state=closed]/collapsible-content:fade-out-0 group-data-[state=closed]/collapsible-content:blur-out-[2px] group-data-[state=closed]/collapsible-content:slide-out-to-top-1",
            "group-data-[state=closed]/collapsible-content:duration-(--animation-duration) group-data-[state=open]/collapsible-content:duration-(--animation-duration)"
          ),
          children: t
        }
      )
    }
  );
}
function Qe({
  argsText: e,
  className: t,
  ...a
}) {
  return e ? /* @__PURE__ */ o("div", { "data-slot": "tool-fallback-args", className: i("aui-tool-fallback-args", t), ...a, children: /* @__PURE__ */ o("pre", { className: "aui-tool-fallback-args-value bg-muted/50 text-foreground/90 rounded-md p-2.5 text-xs whitespace-pre-wrap", children: e }) }) : null;
}
function Ze({
  result: e,
  className: t,
  ...a
}) {
  return e === void 0 ? null : /* @__PURE__ */ l("div", { "data-slot": "tool-fallback-result", className: i("aui-tool-fallback-result", t), ...a, children: [
    /* @__PURE__ */ o("p", { className: "aui-tool-fallback-result-header text-muted-foreground text-xs font-medium", children: "Result:" }),
    /* @__PURE__ */ o("pre", { className: "aui-tool-fallback-result-content bg-muted/50 text-foreground/90 mt-1 rounded-md p-2.5 text-xs whitespace-pre-wrap", children: typeof e == "string" ? e : JSON.stringify(e, null, 2) })
  ] });
}
const me = (e) => {
  if (e == null) return null;
  if (typeof e == "string") return e;
  if (typeof e == "object" && "error" in e) {
    const t = e.error;
    return typeof t == "string" ? t : JSON.stringify(t);
  }
  return JSON.stringify(e);
};
function et({
  status: e,
  isError: t,
  result: a,
  className: n,
  ...r
}) {
  const s = e?.type === "incomplete" && e.reason === "cancelled";
  let c, u;
  if (e?.type === "incomplete")
    u = me(e.error), c = s ? "Cancelled reason:" : "Error:";
  else if (t)
    u = me(a), c = "Error:";
  else
    return null;
  if (!u) return null;
  const b = s;
  return /* @__PURE__ */ l("div", { "data-slot": "tool-fallback-error", className: i("aui-tool-fallback-error", n), ...r, children: [
    /* @__PURE__ */ o(
      "p",
      {
        className: i(
          "aui-tool-fallback-error-header font-semibold",
          b ? "text-muted-foreground" : "text-destructive"
        ),
        children: c
      }
    ),
    /* @__PURE__ */ o("p", { className: i("aui-tool-fallback-error-reason", b ? "text-muted-foreground" : "text-destructive"), children: u })
  ] });
}
const ko = "Approved by user", Co = "User denied tool execution", W = {
  "allow-once": "Allow",
  "allow-always": "Always allow",
  "reject-once": "Deny",
  "reject-always": "Always deny"
}, pe = (e) => e === "allow-once" || e === "allow-always", fe = (e) => e.label ?? (Object.hasOwn(W, e.kind) ? W[e.kind] : void 0) ?? e.id;
function tt({
  className: e,
  addResult: t,
  resume: a,
  interrupt: n,
  approval: r,
  respondToApproval: s,
  ...c
}) {
  const [u, b] = C(!1), [m, f] = C(null);
  if (r != null && (r.approved !== void 0 || r.resolution !== void 0)) return null;
  const d = s ? r?.options : void 0, g = d?.filter((p) => Object.hasOwn(W, p.kind)), h = (p) => {
    u || (r != null && r.approved === void 0 && s ? s({ approved: p }) : n ? a?.({ approved: p }) : t?.(p ? ko : Co), b(!0));
  }, v = (p) => {
    u || (s?.({ optionId: p.id }), b(!0), f(null));
  }, k = (p) => {
    p.confirm ? f(p.id) : v(p);
  }, x = m != null ? g?.find((p) => p.id === m) : void 0;
  if (x) {
    const p = typeof x.confirm == "object" ? x.confirm : void 0, M = p?.description ?? x.description;
    return /* @__PURE__ */ l(
      "div",
      {
        "data-slot": "tool-fallback-approval-confirm",
        className: i("aui-tool-fallback-approval-confirm flex flex-col gap-2 pt-1", e),
        ...c,
        children: [
          /* @__PURE__ */ o("p", { className: "aui-tool-fallback-approval-confirm-title font-semibold", children: p?.title ?? `${fe(x)}?` }),
          M && /* @__PURE__ */ o("p", { className: "aui-tool-fallback-approval-confirm-description text-muted-foreground", children: M }),
          x.grants && x.grants.length > 0 && /* @__PURE__ */ o("ul", { className: "aui-tool-fallback-approval-confirm-grants flex flex-col gap-1", children: x.grants.map((w) => /* @__PURE__ */ o("li", { children: /* @__PURE__ */ o("code", { className: "aui-tool-fallback-approval-confirm-grant bg-muted rounded px-1.5 py-0.5 text-xs", children: w }) }, w)) }),
          /* @__PURE__ */ l("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ o(R, { size: "sm", className: z, onClick: () => v(x), disabled: u, children: "Confirm" }),
            /* @__PURE__ */ o(
              R,
              {
                size: "sm",
                variant: "outline",
                className: z,
                onClick: () => f(null),
                disabled: u,
                children: "Back"
              }
            )
          ] })
        ]
      }
    );
  }
  if (d && d.length > 0) {
    const p = g?.filter((w) => pe(w.kind)) ?? [], M = g?.filter((w) => !pe(w.kind)) ?? [];
    return /* @__PURE__ */ l(
      "div",
      {
        "data-slot": "tool-fallback-approval",
        className: i("aui-tool-fallback-approval flex flex-wrap items-center gap-2 pt-1", e),
        ...c,
        children: [
          [...p, ...M].map((w) => /* @__PURE__ */ o(
            R,
            {
              size: "sm",
              variant: w === p[0] ? "default" : "outline",
              className: z,
              onClick: () => k(w),
              disabled: u,
              children: fe(w)
            },
            w.id
          )),
          M.length === 0 && /* @__PURE__ */ o(R, { size: "sm", variant: "outline", className: z, onClick: () => h(!1), disabled: u, children: "Deny" })
        ]
      }
    );
  }
  return /* @__PURE__ */ l(
    "div",
    {
      "data-slot": "tool-fallback-approval",
      className: i("aui-tool-fallback-approval flex items-center gap-2 pt-1", e),
      ...c,
      children: [
        /* @__PURE__ */ o(R, { size: "sm", className: z, onClick: () => h(!0), disabled: u, children: "Allow" }),
        /* @__PURE__ */ o(R, { size: "sm", variant: "outline", className: z, onClick: () => h(!1), disabled: u, children: "Deny" })
      ]
    }
  );
}
const Ao = ({
  toolName: e,
  argsText: t,
  result: a,
  isError: n,
  status: r,
  addResult: s,
  resume: c,
  interrupt: u,
  approval: b,
  respondToApproval: m
}) => {
  const f = r?.type === "incomplete" && r.reason === "cancelled", d = r?.type === "requires-action", g = d || n === !0, [h, v] = C(g), [k, x] = C(g);
  return g !== k && (x(g), g && v(!0)), /* @__PURE__ */ l(Ke, { open: h, onOpenChange: v, children: [
    /* @__PURE__ */ o(Je, { toolName: e, status: r, isError: n }),
    /* @__PURE__ */ l(Ye, { children: [
      /* @__PURE__ */ o(et, { status: r, isError: n, result: a }),
      /* @__PURE__ */ o(Qe, { argsText: t, className: i(f && "opacity-60") }),
      d && /* @__PURE__ */ o(
        tt,
        {
          addResult: s,
          resume: c,
          interrupt: u,
          approval: b,
          respondToApproval: m
        }
      ),
      !f && !n && /* @__PURE__ */ o(Ze, { result: a })
    ] })
  ] });
}, E = ye(Ao);
E.displayName = "ToolFallback";
E.Root = Ke;
E.Trigger = Je;
E.Content = Ye;
E.Args = Qe;
E.Result = Ze;
E.Error = et;
E.Approval = tt;
const te = O(void 0), ot = O(void 0), at = [], nt = O(at), rt = O(void 0), ge = pt({
  reasoning: ["group-execution"],
  "tool-call": ["group-execution"],
  "standalone-tool-call": []
});
function To(e) {
  if (e.length === 0) return ge;
  const t = new Set(e);
  return (a, n) => a.type === "tool-call" && t.has(a.toolName) ? [] : ge(a, n);
}
const Io = "44rem", F = "mx-auto w-full max-w-(--thread-max-width)", it = {}, D = O(it), st = "Send a message...", lt = O(st), he = (e) => e.thread.messages.length === 0 && (!e.thread.isLoading || e.threads.isLoading), fa = ({
  components: e = it,
  suggestions: t,
  composerPlaceholder: a = st,
  messageTimeLabel: n,
  daySeparatorLabel: r,
  messageActions: s = at,
  workingLabels: c
}) => /* @__PURE__ */ o(D.Provider, { value: e, children: /* @__PURE__ */ o(lt.Provider, { value: a, children: /* @__PURE__ */ o(te.Provider, { value: r, children: /* @__PURE__ */ o(ot.Provider, { value: n, children: /* @__PURE__ */ o(nt.Provider, { value: s, children: /* @__PURE__ */ o(rt.Provider, { value: c, children: /* @__PURE__ */ o(Ro, { suggestions: t }) }) }) }) }) }) }), Ro = ({ suggestions: e }) => {
  const { Welcome: t = _o } = N(D);
  return /* @__PURE__ */ o(
    P.Root,
    {
      className: "aui-root aui-thread-root bg-background @container flex h-full flex-col",
      style: {
        "--thread-max-width": Io,
        // Match the legacy `TextArea`: white surface, 4px corners, no fill tint.
        "--composer-bg": "var(--color-background)",
        "--composer-radius": "4px",
        "--composer-padding": "8px"
      },
      children: /* @__PURE__ */ o(
        P.Viewport,
        {
          "data-slot": "aui_thread-viewport",
          className: "relative flex flex-1 flex-col overflow-x-auto overflow-y-scroll scroll-smooth",
          children: /* @__PURE__ */ l("div", { className: "mx-auto flex w-full max-w-[var(--thread-content-max-width,var(--thread-max-width))] flex-1 flex-col px-4 pt-4", children: [
            /* @__PURE__ */ o(T, { condition: he, children: /* @__PURE__ */ o(t, {}) }),
            /* @__PURE__ */ o("div", { "data-slot": "aui_message-group", className: "mb-14 flex flex-col gap-y-6 empty:hidden", children: /* @__PURE__ */ o(P.Messages, { children: () => /* @__PURE__ */ o(So, {}) }) }),
            /* @__PURE__ */ l(P.ViewportFooter, { className: "aui-thread-viewport-footer bg-background sticky bottom-0 z-20 mt-auto flex flex-col gap-4 overflow-visible rounded-t-(--composer-radius) pb-4 md:pb-6", children: [
              /* @__PURE__ */ o(Oo, {}),
              /* @__PURE__ */ o(Po, {}),
              /* @__PURE__ */ o(T, { condition: (a) => he(a) && a.composer.isEmpty, children: /* @__PURE__ */ o(Do, { suggestions: e }) })
            ] })
          ] })
        }
      )
    }
  );
}, So = () => {
  const { AssistantMessage: e = Bo } = N(D), t = y((n) => n.message.role), a = Eo();
  return /* @__PURE__ */ l(ut, { children: [
    a !== void 0 && /* @__PURE__ */ o(Mo, { timestampMs: a }),
    t === "user" ? /* @__PURE__ */ o(Go, {}) : /* @__PURE__ */ o(e, {})
  ] });
};
function V(e) {
  const t = e.metadata.custom?.createdAt;
  return typeof t == "number" ? t : void 0;
}
function Eo() {
  const e = N(te);
  return y((t) => {
    if (!e) return;
    const a = V(t.message);
    if (a !== void 0) {
      for (let n = t.message.index - 1; n >= 0; n--) {
        const r = V(t.thread.messages[n]);
        if (r !== void 0)
          return G.fromMillis(r).hasSame(G.fromMillis(a), "day") ? void 0 : a;
      }
      return a;
    }
  });
}
const Mo = ({ timestampMs: e }) => {
  const t = N(te);
  if (!t) return null;
  const a = t(e);
  return a ? /* @__PURE__ */ o(
    "div",
    {
      "data-slot": "aui_day-separator",
      ...It("Body/S/Medium"),
      className: "bg-background sticky top-0 z-10 -mx-4 border-b border-[var(--palette-N100)] px-4 py-1.5 text-center text-[var(--palette-N400)]",
      children: a
    }
  ) : null;
}, Oo = () => /* @__PURE__ */ o(P.ScrollToBottom, { asChild: !0, children: /* @__PURE__ */ o(
  I,
  {
    tooltip: "Scroll to bottom",
    variant: "outline",
    className: "aui-thread-scroll-to-bottom dark:border-border dark:bg-background dark:hover:bg-accent absolute -top-12 z-10 self-center rounded-full p-4 disabled:invisible",
    children: /* @__PURE__ */ o(Nt, {})
  }
) }), _o = () => /* @__PURE__ */ o("div", { className: "aui-thread-welcome-root mb-6 flex flex-col items-center px-4 text-center", children: /* @__PURE__ */ o("h1", { className: "aui-thread-welcome-message-inner fade-in slide-in-from-bottom-1 animate-in fill-mode-both text-2xl font-semibold duration-200", children: "How can I help you today?" }) }), Do = ({ suggestions: e }) => (
  // `empty:hidden`: with no suggestions this renders no children, so the wrapper must
  // collapse — otherwise it stays a flow child of the footer and reserves the `gap-4`
  // above it, shifting the composer between the welcome and message states (the "jump").
  // Same pattern as the message group above.
  /* @__PURE__ */ o("div", { className: "aui-thread-welcome-suggestions flex w-full flex-wrap items-center justify-center gap-2 px-4 empty:hidden", children: e?.map((t) => /* @__PURE__ */ o(zo, { suggestion: t }, t.prompt)) })
), zo = ({ suggestion: e }) => {
  const t = (a) => {
    const n = a.currentTarget.closest(".aui-thread-root")?.querySelector(".aui-composer-input");
    n && requestAnimationFrame(() => {
      n.focus({ preventScroll: !0 }), n.setSelectionRange(n.value.length, n.value.length);
    });
  };
  return /* @__PURE__ */ o("div", { className: "aui-thread-welcome-suggestion-display fade-in slide-in-from-bottom-2 animate-in fill-mode-both duration-200", children: /* @__PURE__ */ o(P.Suggestion, { prompt: e.prompt, send: !1, asChild: !0, children: /* @__PURE__ */ o(
    R,
    {
      variant: "ghost",
      onClick: t,
      className: "aui-thread-welcome-suggestion text-foreground hover:bg-muted border-border/60 h-auto max-w-full gap-1.5 rounded-full border px-3.5 py-1.5 text-left text-sm font-normal whitespace-normal transition-colors",
      children: e.label ?? e.prompt
    }
  ) }) });
}, Po = () => {
  const { Composer: e } = N(D), t = /* @__PURE__ */ o(Lo, {});
  return /* @__PURE__ */ o("div", { className: "mx-auto w-full max-w-(--thread-max-width)", children: e ? /* @__PURE__ */ o(e, { children: t }) : t });
}, Lo = () => {
  const e = N(lt);
  return /* @__PURE__ */ o(S.Root, { className: "aui-composer-root relative flex w-full flex-col", children: /* @__PURE__ */ o(S.AttachmentDropzone, { asChild: !0, children: /* @__PURE__ */ l(
    "div",
    {
      "data-slot": "aui_composer-shell",
      className: "border-border focus-within:border-foreground/50 data-[dragging=true]:border-ring flex w-full flex-col gap-2 rounded-(--composer-radius) border bg-(--composer-bg) p-(--composer-padding) transition-[border-color] data-[dragging=true]:border-dashed data-[dragging=true]:bg-[color-mix(in_oklab,var(--color-accent)_50%,var(--color-background))]",
      children: [
        /* @__PURE__ */ o(Xt, {}),
        /* @__PURE__ */ o(
          S.Input,
          {
            placeholder: e,
            className: "aui-composer-input placeholder:text-muted-foreground/80 max-h-32 min-h-10 w-full resize-none bg-transparent px-2.5 py-1 text-base outline-none",
            rows: 1,
            autoFocus: !0,
            "aria-label": "Message input",
            "data-qualifier": "SphereAI/Composer/Input"
          }
        ),
        /* @__PURE__ */ o(jo, {})
      ]
    }
  ) }) });
}, jo = () => {
  const { ComposerActionExtra: e, ComposerContext: t } = N(D);
  return /* @__PURE__ */ l("div", { className: "aui-composer-action-wrapper relative flex items-center justify-between gap-2", children: [
    /* @__PURE__ */ l("div", { className: "flex min-w-0 flex-1 items-center gap-2", children: [
      /* @__PURE__ */ o(Kt, {}),
      /* @__PURE__ */ o("div", { className: "aui-composer-context before:bg-border flex min-w-0 items-center empty:hidden before:me-2 before:h-4 before:w-px before:shrink-0 before:content-['']", children: t ? /* @__PURE__ */ o(t, {}) : null })
    ] }),
    /* @__PURE__ */ l("div", { className: "flex shrink-0 items-center gap-1.5", children: [
      e ? /* @__PURE__ */ o(e, {}) : null,
      /* @__PURE__ */ l(T, { condition: (a) => a.thread.capabilities.dictation, children: [
        /* @__PURE__ */ o(T, { condition: (a) => a.composer.dictation == null, children: /* @__PURE__ */ o(S.Dictate, { asChild: !0, children: /* @__PURE__ */ o(
          I,
          {
            tooltip: "Voice input",
            side: "bottom",
            type: "button",
            variant: "ghost",
            size: "icon",
            className: "aui-composer-dictate size-7 rounded-full",
            "aria-label": "Start voice input",
            children: /* @__PURE__ */ o(kt, { className: "aui-composer-dictate-icon size-4" })
          }
        ) }) }),
        /* @__PURE__ */ o(T, { condition: (a) => a.composer.dictation != null, children: /* @__PURE__ */ o(S.StopDictation, { asChild: !0, children: /* @__PURE__ */ o(
          I,
          {
            tooltip: "Stop dictation",
            side: "bottom",
            type: "button",
            variant: "ghost",
            size: "icon",
            className: "aui-composer-stop-dictation text-destructive size-7 rounded-full",
            "aria-label": "Stop voice input",
            children: /* @__PURE__ */ o(ae, { className: "aui-composer-stop-dictation-icon size-3.5 animate-pulse fill-current" })
          }
        ) }) })
      ] }),
      /* @__PURE__ */ o(T, { condition: (a) => !a.thread.isRunning, children: /* @__PURE__ */ o(S.Send, { asChild: !0, children: /* @__PURE__ */ o(
        I,
        {
          tooltip: "Send message",
          side: "bottom",
          type: "button",
          variant: "default",
          size: "icon",
          className: "aui-composer-send size-7 rounded-full",
          "aria-label": "Send message",
          "data-qualifier": "SphereAI/Composer/Send",
          children: /* @__PURE__ */ o(Ct, { className: "aui-composer-send-icon size-4.5" })
        }
      ) }) }),
      /* @__PURE__ */ o(T, { condition: (a) => a.thread.isRunning, children: /* @__PURE__ */ o(S.Cancel, { asChild: !0, children: /* @__PURE__ */ o(
        R,
        {
          type: "button",
          variant: "default",
          size: "icon",
          className: "aui-composer-cancel size-7 rounded-full",
          "aria-label": "Stop generating",
          children: /* @__PURE__ */ o(ae, { className: "aui-composer-cancel-icon size-3.5 fill-current" })
        }
      ) }) })
    ] })
  ] });
}, Uo = () => /* @__PURE__ */ o(j.Error, { children: /* @__PURE__ */ o(
  oe.Root,
  {
    "data-qualifier": "SphereAI/Message/Error",
    className: i(
      F,
      "aui-message-error-root border-destructive bg-destructive/10 text-destructive dark:bg-destructive/5 mt-2 rounded-md border p-3 text-sm dark:text-red-200"
    ),
    children: /* @__PURE__ */ o(oe.Message, { className: "aui-message-error-message" })
  }
) }), be = ({ part: e }) => {
  const { inExecution: t, detailsShown: a } = Z();
  return t ? /* @__PURE__ */ o(Ge, { active: e.status.type === "running", children: a ? /* @__PURE__ */ o(de, {}) : ee(e) }) : /* @__PURE__ */ o(de, {});
}, Fo = ({ part: e, Fallback: t }) => {
  const { inExecution: a, detailsShown: n } = Z(), r = e.toolUI ?? /* @__PURE__ */ o(t, { ...e });
  return a ? /* @__PURE__ */ o(Ge, { active: e.status?.type === "running", children: n ? r : ee(e) }) : /* @__PURE__ */ o("div", { className: F, children: r });
}, Bo = () => {
  const {
    ToolFallback: e = E,
    Tools: t,
    AssistantMessageExtra: a
  } = N(D), n = N(rt), r = y((d) => d.message.parts), s = y((d) => d.message.status?.type === "running"), c = bo(r, r.length - 1, s) ? r[r.length - 1] : void 0, u = L(() => {
    const d = t ? Object.keys(t) : [], g = To(d), h = Xe(r, d);
    return h.size === 0 && c === void 0 ? g : (v, k) => v.type === "text" && (h.has(v) || v === c) ? ["group-execution"] : g(v, k);
  }, [t, r, c]), b = y((d) => {
    const g = d.message.metadata.custom?.createdAt;
    return typeof g == "number" ? g : void 0;
  });
  return /* @__PURE__ */ l(
    j.Root,
    {
      "data-slot": "aui_assistant-message-root",
      "data-role": "assistant",
      "data-qualifier": "SphereAI/Message/Assistant",
      className: "fade-in slide-in-from-bottom-1 animate-in group/message relative duration-150",
      children: [
        /* @__PURE__ */ l(
          "div",
          {
            "data-slot": "aui_assistant-message-content",
            className: "text-foreground px-2 leading-relaxed wrap-break-word [contain-intrinsic-size:auto_24px] [content-visibility:auto]",
            children: [
              /* @__PURE__ */ o(j.GroupedParts, { groupBy: u, indicator: "empty", children: ({ part: d, children: g }) => {
                switch (d.type) {
                  case "group-execution": {
                    const h = d.indices[d.indices.length - 1] ?? -1, v = r.some((w, dt) => dt > h && w.type === "text"), k = s && !v, x = c !== void 0 && r[h] === c ? d.indices.slice(0, -1) : d.indices, p = r[x[x.length - 1] ?? -1], M = x.length;
                    return /* @__PURE__ */ l(eo, { active: k, className: i(F, "mb-2"), children: [
                      /* @__PURE__ */ o(
                        no,
                        {
                          active: k,
                          startedAt: b,
                          workingLabels: n,
                          detail: k ? p && ee(p) : `${M} step${M === 1 ? "" : "s"}`
                        }
                      ),
                      /* @__PURE__ */ l(ro, { "aria-busy": k || void 0, children: [
                        /* @__PURE__ */ o(io, { children: g }),
                        /* @__PURE__ */ o(so, { className: "ms-5" })
                      ] })
                    ] });
                  }
                  case "text":
                    return c !== void 0 && d.status.type === "running" ? null : /* @__PURE__ */ o(be, { part: d });
                  case "reasoning":
                    return /* @__PURE__ */ o(be, { part: d });
                  case "tool-call": {
                    const h = t?.[d.toolName];
                    return h ? /* @__PURE__ */ o(h, { ...d }) : /* @__PURE__ */ o(Fo, { part: d, Fallback: e });
                  }
                  case "data":
                    return d.dataRendererUI;
                  case "indicator":
                    return /* @__PURE__ */ o(
                      "output",
                      {
                        "data-slot": "aui_assistant-message-indicator",
                        className: "animate-pulse font-sans",
                        "aria-label": "Assistant is working",
                        children: "●"
                      }
                    );
                  default:
                    return null;
                }
              } }),
              a ? /* @__PURE__ */ o("div", { className: F, children: /* @__PURE__ */ o(a, {}) }) : null,
              /* @__PURE__ */ o(Uo, {})
            ]
          }
        ),
        /* @__PURE__ */ l(
          "div",
          {
            "data-slot": "aui_assistant-message-footer",
            className: i(F, "flex items-center ps-2", "-mb-7.5 min-h-7.5 pt-1.5"),
            children: [
              /* @__PURE__ */ o(qo, {}),
              /* @__PURE__ */ o(ct, { className: "ms-1" })
            ]
          }
        )
      ]
    }
  );
}, ct = ({ className: e }) => {
  const t = N(ot), a = y((r) => {
    const s = r.message.metadata.custom?.createdAt;
    return typeof s == "number" ? s : void 0;
  });
  if (!t || a === void 0) return null;
  const n = t(a);
  return n ? /* @__PURE__ */ o(
    "time",
    {
      "data-slot": "aui_message-timestamp",
      dateTime: G.fromMillis(a).toISO() ?? void 0,
      className: i(
        "text-muted-foreground pointer-events-none text-xs whitespace-nowrap opacity-0 transition-opacity duration-150 select-none group-hover/message:opacity-100 group-focus-within/message:opacity-100",
        e
      ),
      children: n
    }
  ) : null;
}, Ho = ({ held: e }) => /* @__PURE__ */ o(ft.Root, { open: e }), $o = ({ state: e, ...t }) => /* @__PURE__ */ l(
  I,
  {
    tooltip: "More",
    className: "data-[state=open]:bg-accent",
    ...t,
    children: [
      /* @__PURE__ */ o(Ho, { held: t["data-state"] === "open" || e === "loading" }),
      e === "loading" ? /* @__PURE__ */ o(wt, { className: "animate-spin" }) : /* @__PURE__ */ o(yt, {})
    ]
  }
), qo = () => {
  const { Tools: e } = N(D), t = N(nt), a = X(), n = y((m) => m.message.parts), r = y((m) => V(m.message)), s = L(() => {
    if (t.length === 0) return { parts: n, answerParts: n, createdAt: r };
    const m = Xe(n, e ? Object.keys(e) : []);
    return {
      parts: n,
      answerParts: n.filter((f) => !m.has(f)),
      createdAt: r
    };
  }, [t.length, n, e, r]), c = L(() => n.some((m) => m.type === "text" && m.text.length > 0), [n]), u = Y(async () => {
    const m = a.message().getCopyText();
    if (!m) return;
    const f = URL.createObjectURL(new Blob([m], { type: "text/markdown" })), d = document.createElement("a");
    d.href = f, d.download = `message-${Date.now()}.md`, d.click(), URL.revokeObjectURL(f);
  }, [a]), b = L(
    () => [
      {
        label: "Export as Markdown",
        // The icon set has no format marks beyond xls/ppt/pdf, so these say "a document" and
        // "plain text" and let the labels carry the format.
        icon: "free-text",
        disabled: !c,
        onClickAsync: u
      },
      ...t.map(
        (m) => ({
          label: m.label,
          ...m.icon && { icon: m.icon },
          onClickAsync: async () => {
            await m.run(s);
          }
        })
      )
    ],
    [u, c, t, s]
  );
  return /* @__PURE__ */ l(
    H.Root,
    {
      hideWhenRunning: !0,
      autohide: "not-last",
      className: "aui-assistant-action-bar-root text-muted-foreground animate-in fade-in col-start-3 row-start-2 -ms-1 flex gap-1 duration-200",
      children: [
        /* @__PURE__ */ o(H.Copy, { asChild: !0, children: /* @__PURE__ */ l(I, { tooltip: "Copy", children: [
          /* @__PURE__ */ o(T, { condition: (m) => m.message.isCopied, children: /* @__PURE__ */ o($, { className: "animate-in zoom-in-50 fade-in duration-200 ease-out" }) }),
          /* @__PURE__ */ o(T, { condition: (m) => !m.message.isCopied, children: /* @__PURE__ */ o(K, { className: "animate-in zoom-in-75 fade-in duration-150" }) })
        ] }) }),
        /* @__PURE__ */ o(Rt, { Trigger: $o, actions: b })
      ]
    }
  );
}, Go = () => /* @__PURE__ */ l(
  j.Root,
  {
    "data-slot": "aui_user-message-root",
    className: "fade-in slide-in-from-bottom-1 animate-in group/message mx-auto grid w-full max-w-(--thread-max-width) auto-rows-auto grid-cols-[minmax(72px,1fr)_auto] content-start gap-y-2 px-2 duration-150 [&:where(>*)]:col-start-2",
    "data-role": "user",
    children: [
      /* @__PURE__ */ o(Vt, {}),
      /* @__PURE__ */ l("div", { className: "aui-user-message-content-wrapper relative col-start-2 min-w-0", children: [
        /* @__PURE__ */ o("div", { className: "aui-user-message-content bg-muted text-foreground max-w-(--thread-max-width) rounded-xl px-4 py-2 wrap-break-word empty:hidden", children: /* @__PURE__ */ o(j.Parts, {}) }),
        /* @__PURE__ */ l("div", { className: "pointer-events-none absolute inset-x-0 top-full flex items-center justify-end gap-1 pt-1 group-focus-within/message:pointer-events-auto group-hover/message:pointer-events-auto", children: [
          /* @__PURE__ */ o(Wo, {}),
          /* @__PURE__ */ o(ct, {})
        ] })
      ] })
    ]
  }
), Wo = () => /* @__PURE__ */ o(H.Root, { className: "aui-user-action-bar-root text-muted-foreground flex opacity-0 transition-opacity duration-150 group-focus-within/message:opacity-100 group-hover/message:opacity-100", children: /* @__PURE__ */ o(H.Copy, { asChild: !0, children: /* @__PURE__ */ l(I, { tooltip: "Copy", children: [
  /* @__PURE__ */ o(T, { condition: (e) => e.message.isCopied, children: /* @__PURE__ */ o($, { className: "animate-in zoom-in-50 fade-in duration-200 ease-out" }) }),
  /* @__PURE__ */ o(T, { condition: (e) => !e.message.isCopied, children: /* @__PURE__ */ o(K, { className: "animate-in zoom-in-75 fade-in duration-150" }) })
] }) }) });
export {
  ce as HANDLE_SCHEME,
  pa as InlineRefResolverProvider,
  de as MarkdownText,
  Io as THREAD_READING_MAX_WIDTH,
  fa as Thread,
  E as ToolFallback,
  I as TooltipIconButton,
  co as handleOf,
  uo as remarkInlineRefs
};
//# sourceMappingURL=index.js.map
